/**
 * Pure helpers for reordering process-management roles/stages.
 */

/**
 * Move item from fromIndex to toIndex (immutable).
 * @template T
 * @param {T[]} items
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {T[]}
 */
export function moveItemInArray(items, fromIndex, toIndex) {
  const list = items || [];
  if (
    fromIndex === toIndex
    || fromIndex < 0
    || toIndex < 0
    || fromIndex >= list.length
    || toIndex >= list.length
  ) {
    return list;
  }
  const next = [...list];
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);
  return next;
}

/**
 * Swap item with neighbour. direction: -1 = toward start, +1 = toward end.
 * @template T
 * @param {T[]} items
 * @param {number} index
 * @param {number} direction
 * @returns {T[]}
 */
export function swapAdjacentInArray(items, index, direction) {
  const list = items || [];
  const target = index + direction;
  if (index < 0 || target < 0 || index >= list.length || target >= list.length) {
    return list;
  }
  return moveItemInArray(list, index, target);
}

/** @param {Array<{id: number|string}>} items */
export function idsInOrder(items) {
  return (items || []).map((item) => item.id);
}
